import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { 
    CustomerList, 
    CustomerDetail, 
    CustomerUpdate, 
    CustomerSearchCriteria,
    CustomerCreate 
} from '../../_models/customer.model';
import { ApiResponse } from '../../_models/api-response.model';
import { Page } from '../../_models/page.model';

@Injectable({
    providedIn: 'root'
})
export class CustomerAdminService {
    private adminApiUrl = `${environment.apiUrl}/admin/customers`;

    constructor(private http: HttpClient) { }

    getAllCustomers(
        criteria: CustomerSearchCriteria = {},
        page: number = 0,
        size: number = 10,
        sort: string = 'createdAt',
        direction: string = 'DESC'
    ): Observable<ApiResponse<Page<CustomerList>>> {
        let params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString())
            .set('sort', sort)
            .set('direction', direction);

        if (criteria.search) {
            params = params.set('search', criteria.search);
        }
        if (criteria.isEnabled !== undefined) {
            params = params.set('isEnabled', criteria.isEnabled.toString());
        }
        if (criteria.emailVerified !== undefined) {
            params = params.set('emailVerified', criteria.emailVerified.toString());
        }
        if (criteria.companyName) {
            params = params.set('companyName', criteria.companyName);
        }
        if (criteria.vatNumber) {
            params = params.set('vatNumber', criteria.vatNumber);
        }

        return this.http.get<ApiResponse<Page<CustomerList>>>(this.adminApiUrl, { params });
    }

    getCustomerDetails(customerId: number): Observable<ApiResponse<CustomerDetail>> {
        return this.http.get<ApiResponse<CustomerDetail>>(`${this.adminApiUrl}/${customerId}`);
    }

    createCustomer(customerCreate: CustomerCreate): Observable<ApiResponse<CustomerDetail>> {
        return this.http.post<ApiResponse<CustomerDetail>>(this.adminApiUrl, customerCreate);
    }

    updateCustomer(
        customerId: number, 
        customerUpdate: CustomerUpdate
    ): Observable<ApiResponse<CustomerDetail>> {
        return this.http.put<ApiResponse<CustomerDetail>>(
            `${this.adminApiUrl}/${customerId}`,
            customerUpdate
        );
    }

    enableCustomer(customerId: number): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.adminApiUrl}/${customerId}/enable`,
            {}
        );
    }

    disableCustomer(customerId: number): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.adminApiUrl}/${customerId}/disable`,
            {}
        );
    }

    verifyCustomerEmail(customerId: number): Observable<ApiResponse<void>> {
        return this.http.post<ApiResponse<void>>(
            `${this.adminApiUrl}/${customerId}/verify-email`,
            {}
        );
    }

    deleteCustomer(customerId: number): Observable<ApiResponse<void>> {
        return this.http.delete<ApiResponse<void>>(`${this.adminApiUrl}/${customerId}`);
    }
}